import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { spacings, types, } from './constants';
const spacingStyles = {
    [spacings.none]: theme.spacing.none,
    [spacings.small]: theme.spacing.x2,
    [spacings.medium]: theme.spacing.x4,
    [spacings.large]: theme.spacing.x8,
    [spacings.extraLarge]: theme.spacing.x16,
};
const variationStyles = {
    [types.dark]: {
        borderColor: theme.colors.gray600,
        color: theme.colors.gray600,
    },
    [types.light]: {
        borderColor: theme.colors.gray300,
        color: theme.colors.gray500,
    },
};
const defaultProps = {
    spacing: spacings.small,
    title: '',
    type: types.dark,
};
const Divider = ({ spacing = defaultProps.spacing, title = defaultProps.title, type = defaultProps.type, }) => {
    const titleStyles = useMemo(() => (css `
        ${theme.typeStyles.captionMediumStyles}
        color: ${variationStyles[type].color};
        flex: 0 0 auto;
        font-weight: ${theme.typeStyles.fontWeightBook};
        padding-left: ${styleUtils.rem(8)};
        padding-right: ${styleUtils.rem(8)};
      `), [
        type,
    ]);
    const lineStyles = useMemo(() => (css `
        border-top: ${styleUtils.rem(1)} solid ${variationStyles[type].borderColor};
        flex: 1 1 0;
      `), [
        type,
    ]);
    const lineContainerStyles = useMemo(() => (css `
        align-items: center;
        display: flex;
        margin-bottom: ${spacingStyles[spacing]};
        margin-top: ${spacingStyles[spacing]};
      `), [
        spacing,
    ]);
    const line = (_jsx("div", { css: lineStyles }));
    return (_jsxs("div", Object.assign({ css: lineContainerStyles }, { children: [line, title && (_jsx("span", Object.assign({ css: titleStyles }, { children: title }))), line] })));
};
export { Divider };
